import React, { ReactElement, useCallback, useContext, useEffect, useMemo, useState, } from "react";
import { useLocation } from "react-router-dom";
import styles from "../../pages/Home/Home.module.scss";
import CreatePostModal from "../../pages/Home/CreatePost/CreatePostModal";
import {Button, Layout, theme} from "antd";
import iconPlus from "../../assets/png/newIcon/Home Feed/Plus.png";
import iconPhoto from "../../assets/png/newIcon/Home Feed/image.png";
import iconTag from "../../assets/png/newIcon/Home Feed/Tag.png";
import iconLive from "../../assets/png/newIcon/Home Feed/Live 2.png";
import InfiniteScroll from "react-infinite-scroll-component";
import {LazyLoadComponent, trackWindowScroll} from 'react-lazy-load-image-component';
import SkeletonPost from "../../pages/Home/Post/SkeletonPost";
import PostContainer from "../../pages/Home/Post/PostContainer";
import _ from "lodash";
import NoData from "../shared/NoDataDisplay/NoData";
import { useTranslation } from "react-i18next";
import {getToken, getUserData} from "../../service/auth.service";
import FeedCard from "../Feed/FeedCard";
import { HomeContext } from "../../pages/Home/Home.context";
import useFetch, { CachePolicies } from "use-http";
import CommentsDrawer from "../Feed/CommentsDrawer";
import ProfileModal from "../Modal/ProfileModal";
import CenterConfirmModal from "../shared/Modal/CenterConfirmModal";
import { pathRoutes } from "../../props/util.props";
import { FeedParamList } from "../../models/Feeds";
import useParams from "../../hooks/useParams";

import {useAppDispatch, useAppSelector} from "../../hooks";
import {lightbox,} from "../../features/lightbox/lightboxSlice";
import {AppContext} from "src/pages/context/App.context";
import CenterButton from "../shared/button/CenterButton";
import ProfilePopup from "../../pages/Profile/ProfilePopup/ProfilePopup";
import {useInfiniteQuery, useQuery} from "@tanstack/react-query";
import {getFeeds} from "../../api/feeds";
import axios from "axios";

const callLimit = 15;

interface FeedsContentProps {
  style?: any;
  contentStyle?: any;
  params?: any;
  context?: any;
  groupData?: any;
  onPostSuccess?: () => void;
  showBoxCreatePost?: boolean;
  headerContent?: ReactElement;
}

const { useToken } = theme;

export const FeedsContent: React.FunctionComponent<FeedsContentProps> = ({
  style,
  contentStyle,
  params,
  context = HomeContext,
  groupData,
  headerContent,
  showBoxCreatePost = true,
}) => {
  const { t } = useTranslation();
  const location = useLocation();
  const { token } = useToken();

  const homeContext: any = useContext(context);
  // const paramString = useParams(params);

  const [showLiveModal, setShowLiveModal] = useState<boolean>(false);
  const [showModalCreatePost, setShowModalCreatePost] = useState<boolean>(false);
  const [showProfileModal, setShowProfileModal] = useState<boolean>(false);
  const [openComments, setOpenComments] = useState<boolean>(false);

  const [currentFeedId, setCurrentFeedId] = useState<string>();
  const [currentProfileId, setCurrentProfileId] = useState<string>("");
  const [currentPage, setCurrentPage] = useState<number>(1);

  const [feeds, setFeeds] = useState<any[]>([]);
  const [totalFeeds, setTotalFeeds] = useState<number>(-1);

  const { isOpen, images, currentIndex } = useAppSelector(lightbox);
  const dispatch = useAppDispatch();
  const [isPinType, setIsPinType] = useState<boolean>(false);
  const [search, setSearch] = useState<string>("");
  const [offset, setOffset] = useState<number>(0);
  const [limit, setLimit] = useState<number>(15);

  const appCtx: any = useContext(AppContext);

  const api = useFetch(window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL, {
    cachePolicy: CachePolicies.NO_CACHE,
  });


  // const fetchProducts = async ({ search, limit, offset }: any) => {
  //   return axios
  //       .get<any>(`${window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL}/api/v1/feeds/`, {headers: { Authorization: `Bearer ${getToken()}` }, params: {search, limit, offset}})
  //       .then(res => res.data)
  // };

  const {
    status,
    error,
    hasNextPage,
    fetchNextPage,
    isFetching,
    isLoading,
    isFetchingNextPage,
    isFetchingPreviousPage,
    data,
  } = useInfiniteQuery(
    ['feeds', params],
      ({ pageParam = {search: "", limit: callLimit, offset: 0, params} }) => getFeeds(pageParam),
    {
      // enabled: false,
      refetchOnWindowFocus: false,
      // networkMode: "offlineFirst",
      getNextPageParam: (lastPage, pages) => {
        // console.log("lastPage", lastPage)
        if (lastPage.total < pages.length * callLimit) return false;
        // setCurrentPage(prevState => prevState + 1);
        return {search: "", limit: callLimit, offset: pages.length * callLimit, params};
      }
    }
  )
  //
  // const convertParam = (key: string, value: string) => {
  //     return `&${key}=${value}`
  // }
  //
  // const paramsString =  useMemo(() => {
  //     let p = ""
  //
  //     for (const param of params) {
  //         p += convertParam(param.key, param.value)
  //     }
  //     return p
  // }, [params])

  const onLive = async () => {
    setShowLiveModal(false);
    // navigate(
    //   pathRoutes.PersonalLive +
    //   "?id=" +
    //   homeContext.user?.id +
    //   "&type=publisher"
    // );
  };

  // useEffect(() => {
  //   console.log("hasNextPage", hasNextPage)
  // }, [hasNextPage])

  const sortFeeds = (feeds: any) => {
    feeds.sort((a: any, b: any) => {
      if (a.createdAt > b.createdAt) return -1;
      if (a.createdAt < b.createdAt) return 1;
    });
  };

  // const loadFeeds = async (search: string, limit: number, offset: number) => {
  //   const data = await api.get(
  //     `/api/v1/feeds/?search=${search}&limit=${limit}&offset=${offset}${paramString}`
  //   );
  //   // console.log("Feeds", data?.feeds);
  //   // if (data?.feeds) sortFeeds(data?.feeds);
  //   return data;
  // };

  // const initFeeds = async () => {
  //   const data = await loadFeeds("", callLimit, 0);
  //   // console.log("Feeds", data?.feeds);
  //   if (data) {
  //     setFeeds(data?.feeds);
  //     setTotalFeeds(data?.total);
  //   }
  //   // setTimeout(() => {
  //   //     let a = Array.apply(null, Array(200)).map((a, index) => {
  //   //         return {
  //   //             uniqueId: index,
  //   //             once: [6, 7].indexOf(index) > -1
  //   //         };
  //   //     })
  //   //     setFeeds(a);
  //   // }, 500)
  // };

  const handleBack = () => {
    homeContext.setFeeds(null);
    homeContext.setCurrentPost(null);
    // navigate("/home");
    // navigate(-1)
    // initFeeds();
  };

  const getTag = (mentions: any) => {
    let tagArr: any = [];
    const queryString = new URLSearchParams(location.search);
    const id = queryString.get("id");
    // mentions?.map((item: any, index: number) => {
    //   if (item.mentionID !== mentions.mentionID) return tagArr.push(item);
    // });
    const tags = new Set()
    const filterArray = mentions?.filter((item: any) => {
      const duplicate = tags.has(item?.mentionID)
      tags.add(item?.mentionID)
      return !duplicate
    })
    return filterArray;
  };

  // const paperPin = (bol: boolean) => {
  //   return setIsPinType(bol);
  // }

  const me: any = useMemo(() => {
    console.log("groupData", groupData);

    return groupData?.members?.find((member: any) => {
      return member?.userID === getUserData().id;
    });
  }, [groupData?.members]);

  const canUsePin = useMemo(() => {

    if (!params?.hasOwnProperty('groupID')) return true
    // const hasParam = params.some((keys: any) => {
    //   return keys.key === "groupID";
    // })
    // if (!hasParam) {
    //   return true
    // }
    if ((me?.memberRole === "owner") || (me?.memberRole === "admin")) {
      // paperPin(true);
      return true
    }
    return false;

  }, [me, params])


  // const fetchNextPost = useCallback(async () => {
  //   if (feeds?.length < totalFeeds) {
  //     const comingData = await loadFeeds("", callLimit, feeds?.length);
  //
  //     setFeeds((prev: any) => {
  //       return [...prev, ...comingData.feeds];
  //     });
  //   }
  // }, [feeds, totalFeeds]);

  const toggleModalCreatePost = useCallback(() => {
    setShowModalCreatePost(!showModalCreatePost);
  }, [showModalCreatePost]);

  const hasMorePost = useMemo(() => {
    return feeds.length < totalFeeds;
  }, [feeds, totalFeeds]);

  // useEffect(() => {
  //   // initFeeds();
  //   // fetchNextPage();
  // }, [paramString]);

  // useEffect(() => {
  //
  // }, [canUsePin])

  const renderFeed = useCallback(
    (feed: any) => {
      return (
          <LazyLoadComponent>
        <FeedCard
          key={feed.id}
          id={feed.id}
          avatarURL={feed.user?.imageProfileURL}
          name={
            feed.user?.firstname +
            (_.isEmpty(feed.user?.lastname) ? "" : " " + feed.user?.lastname)
          }
          createdAt={feed.status === "draft" || feed.privacy === "draft" ? feed.updatedAt : feed.publishAt}
          title={feed.title}
          ownerId={feed?.user?.id}
          owner={feed?.user?.username}
          content={feed.content}
          covers={feed?.covers}
          likes={feed.likeUsers}
          isLike={feed?.likeUsers?.some(
            (item: any) =>
              item.usserID === getUserData()?.id ||
              item.usserID === getUserData()?.username
          )}
          isPin={feed?.yourPin}
          canUsePin={canUsePin}
          isPinType={(me?.memberRole === "owner") || (me?.memberRole === "admin")}
          params={params}
          isMyPaperPin={feed?.myPaperPin}
          contentStyle={feed?.styleContent}
          onOpenComments={(feedId: string) => {
            setCurrentFeedId(feedId);
            setOpenComments(true);
          }}
          totalComments={feed?.commentSummary ? feed?.commentSummary : 0}
          privacy={feed?.privacy}
          mentions={getTag(feed?.mentions)}
          categories={feed.categories}
          onEditPost={(post: any) => {
            homeContext.setTitle(post.title);
            homeContext.setContent(post.content);
            homeContext.setPrivacyOption(post.privacyOption);
            homeContext.setOldData(post.oldData);
            homeContext.setOldcover(post.oldCover);
            homeContext.setCaptionStyle(post.captionStyle);

            homeContext.setPreviewCovers(post.previewCovers);
            homeContext.setTag(post.tag);
            homeContext.setCategory(post.categories);

            homeContext.setIsEditPost(true);
            homeContext.setPostID(post.feedId);
            setShowModalCreatePost(true);
          }}
          onDelete={(feedId: string) => {
            let newFeed = feeds.filter((of: any) => {
              return of.id !== feedId;
            });
            setFeeds(newFeed);
            setTotalFeeds((prevTotal) => {
              return prevTotal - 1;
            });
          }}
          onOpenOwnerProfile={(userId: string) => {
            setCurrentProfileId(userId);
            setShowProfileModal(true);
          }}
        />
          </LazyLoadComponent>
      );
    },
    [feeds, canUsePin]
  );

  const renderFeeds = useMemo(() => {
    // console.log("data", data)
    // if (!data) return null;
    // return data?.pages?.map((feed: any) => renderFeed(feed));
    // console.log("data", data)
    return data?.pages?.slice(0, currentPage)?.map(page =>
        page?.feeds?.map((feed: any) => renderFeed(feed))
    )
  }, [data, canUsePin, currentPage]);

  const fetchNextFeeds = useCallback( async () => {
    await fetchNextPage()
    setCurrentPage(prevState => prevState + 1)
  }, [currentPage])

  return (
    <Layout
      id="feeds-layout"
      className={styles.HomeContainer}
      style={{
        width: "auto",
        overflow: "auto",
        ...style,
        backgroundColor: token.colorPrimaryBg,
      }}
    >
      <Layout.Content
        style={{
          width: "100%",
          color: "#000000",
        }}
      >
        <LazyLoadComponent>
          <CommentsDrawer
            feedId={currentFeedId}
            open={openComments}
            onClose={() => {
              setOpenComments(false);
              setCurrentFeedId(undefined);
            }}
          />
          {/*<ProfilePopup*/}
          {/*    show={showProfileModal}*/}
          {/*    onClose={() => {*/}
          {/*      setShowProfileModal(false)*/}
          {/*    }}*/}
          {/*    // onShowConfirmBlock={() => {*/}
          {/*    //     // setShowConfirmBlock(true);*/}
          {/*    // }}*/}
          {/*    onBlock={(friendID: string) => {*/}
          {/*      setShowProfileModal(false);*/}
          {/*      // setMyFriends((prev: any) => {*/}
          {/*      //   let newFriendsData = {*/}
          {/*      //     data: prev?.data?.filter((f: any) => f?.friend?.id !== friendID),*/}
          {/*      //     total: prev.total,*/}
          {/*      //   };*/}
          {/*      //   newFriendsData.total = newFriendsData?.data.length*/}
          {/*      //   return newFriendsData;*/}
          {/*      // });*/}
          {/*      // getBlockAccounts();*/}
          {/*    }}*/}
          {/*    onReport={() => { }}*/}
          {/*    profile={}*/}
          {/*    // friend={currentFriend}*/}
          {/*/>*/}
          <ProfileModal
            visible={showProfileModal}
            userId={currentProfileId}
            onRefresh={() => {}}
            onClose={() => setShowProfileModal(false)}
          />
          <CenterConfirmModal
            cancelText={t("Cancel")}
            confirmText={t("Ok")}
            text={t("Do you want to live")}
            visible={showLiveModal}
            onCancel={() => {
              setShowLiveModal(false);
            }}
            onConfirm={onLive}
          />
          <div style={{ ...contentStyle }} className={styles.PostInside}>
            <CreatePostModal
              show={showModalCreatePost}
              context={homeContext}
              params={params}
              // feedsContext={homeContext}
              group={groupData}
              onRefresh={handleBack}
              onClose={toggleModalCreatePost}
            />
            {showBoxCreatePost && (
              <div className={styles.boxCreatePost}>
                <Button
                  type="text"
                  onClick={toggleModalCreatePost}
                  style={{
                    width: "100%",
                    height: 50,
                    textAlign: "inherit",
                    color: "rgb(0,0,0,0.5)",
                  }}
                >
                  {t("What's on your mind") + "?"}
                </Button>

                <div
                  style={{
                    padding: 19,
                    paddingBottom: 24,
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <div>
                    <img
                      style={{
                        cursor: "pointer",
                        width: "24px",
                        height: "24px",
                      }}
                      src={iconPlus}
                      onClick={toggleModalCreatePost}
                      alt=""
                    ></img>

                    <img
                      src={iconPhoto}
                      style={{
                        marginLeft: 20,
                        width: "24px",
                        height: "24px",
                        cursor: "pointer",
                      }}
                      alt=""
                      onClick={toggleModalCreatePost}
                    />
                    <img
                      src={iconTag}
                      style={{
                        marginLeft: 20,
                        width: "24px",
                        height: "24px",
                        cursor: "pointer",
                      }}
                      alt=""
                      onClick={toggleModalCreatePost}
                    />
                    {appCtx?.objectAccesses?.["GROUP_MAIN_CALL"] ? (
                      <img
                        src={iconLive}
                        style={{
                          marginLeft: 20,
                          cursor: "pointer",
                          color: "gray",
                          width: "24px",
                          height: "24px",
                        }}
                        alt=""
                        onClick={() => {
                          setShowLiveModal(true);
                        }}
                      />
                    ) : null}
                  </div>
                </div>
              </div>
            )}
            {headerContent && headerContent}

            <InfiniteScroll
              dataLength={data?.pages?.length ? data?.pages?.length * callLimit : 0}
              next={fetchNextFeeds}
              hasMore={hasNextPage || false}
              scrollableTarget={"feeds-layout"}
              loader={
                !isFetching && !isFetchingNextPage && !isLoading? null : (
                  <div className={styles.cardPostLoading}>
                    <SkeletonPost />
                  </div>
                )
              }
            >
              <PostContainer header={t("Post")}>
                {(!data || !data.pages || data.pages.length === 0) ? (
                  <SkeletonPost />
                ) : (
                  renderFeeds
                )}
                {(data && data.pages && data.pages.length > 0 && data.pages[0].total === 0) && (
                  <NoData
                    header={t("No post available")}
                    detail={t(
                      "When you share photo and video, they'll appear on your profile"
                    )}
                  />
                )}
              </PostContainer>
            </InfiniteScroll>
          </div>
          {/*<ModalGateway>*/}
          {/*    {isOpen && (*/}
          {/*        <ImageModal onClose={() => dispatch(hide())}>*/}
          {/*            <Carousel*/}
          {/*                currentIndex={currentIndex}*/}
          {/*                views={images}*/}
          {/*                // views={props.covers}*/}
          {/*            />*/}
          {/*        </ImageModal>*/}
          {/*    )}*/}
          {/*</ModalGateway>*/}
        </LazyLoadComponent>
      </Layout.Content>
    </Layout>
  );
};

// export default trackWindowScroll(FeedsContent))